import * as React from 'react';

const TodoHeading = ({ title }) => (
	<h1 className="panel-heading todo-app__title">{title}</h1>
);

export default TodoHeading;
